import * as UI from "../ui.js";

UI.onDataActionClick("alert:dismiss", ({ el, target }) => {
  const alert = target ?? el.closest(".alert");
  alert.remove();
});
